import type React from 'react';

import cn from 'classnames';

import { CheckSmall } from '@shared/assets';

import * as st from './styles.module.scss';

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
	label?: string;
}

export const Checkbox: React.FC<Props> = ({ label, ...props }) => {
	return (
		<div className={st.wrapper}>
			<div className={cn(st.checkbox, props.checked && st.checkbox__checked)}>
				<CheckSmall />
			</div>
			<input className={st.input} type="checkbox" {...props} />
			{label && <label htmlFor={props.id}>{label}</label>}
		</div>
	);
};
